import { __assign } from "tslib";
import { Type } from '@wix/ambassador-seating-v1-seating-plan/types';
import { COLORS, SHAPE_STROKE_COLOR } from '../constants';
import { Shapes } from '../interfaces';
import { isDarkColor } from './color';
var getCategoriesColorsMap = function (categories) {
    var categoriesColorsMap = {};
    categories.forEach(function (category) {
        categoriesColorsMap[category.id] = category.config.color;
    });
    return categoriesColorsMap;
};
export var elementsToShapes = function (plan, shouldUseCategories) {
    var categories = plan.categories, sectors = plan.sectors;
    var categoriesColorsMap = getCategoriesColorsMap(categories);
    var categoryProps = function (element) {
        if (shouldUseCategories) {
            var categoryColor = categoriesColorsMap[element.categoryId];
            return {
                categoryId: element.categoryId,
                shapeColor: categoryColor,
                shapeTextColor: isDarkColor(categoryColor) ? COLORS.WHITE : SHAPE_STROKE_COLOR,
            };
        }
        return {
            categoryId: element.categoryId,
        };
    };
    return sectors.flatMap(function (sector) {
        return sector.elements.map(function (element) {
            var _a, _b;
            return (__assign(__assign(__assign({}, element.config), categoryProps(element)), { label: element.title, seats: element.places, type: getType(element), capacity: element.totalCapacity, startAt: (_b = (_a = element.seqMetaData) === null || _a === void 0 ? void 0 : _a.startAt) === null || _b === void 0 ? void 0 : _b.toString(), id: element.id, sectorLabel: sector.default ? '' : sector.title }));
        });
    });
};
var getType = function (element) {
    switch (element.type) {
        case Type.AREA:
            return Shapes.AREA;
        case Type.ROW:
            return Shapes.ROW;
        case Type.ROUND_TABLE:
            return Shapes.ROUND_TABLE;
        case Type.TABLE:
            return Shapes.TABLE;
        case Type.SHAPE:
            return element.config.shape;
        default:
            return undefined;
    }
};
//# sourceMappingURL=elements-to-shapes.js.map